import { render, staticRenderFns } from "./AboutUs.vue?vue&type=template&id=2f3badfa&scoped=true"
var script = {}
import style0 from "./AboutUs.vue?vue&type=style&index=0&id=2f3badfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3badfa",
  null
  
)

export default component.exports